export enum ConciergeAppointmentQuestionFlow {
  TestDriveAppointment = 'TestDriveAppointment',
  AdviserSelectionAppointment = 'AdviserSelectionAppointment'
}
export enum ConciergeEventMediaRoutes {
  General = 'general',
  French = 'francais',
  English = 'english'
}
export enum FlowPreSelection {
  None = 'none',
  Adviser = 'adviser',
  TestDrive = 'test_drive'
}
